import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import Select from 'components/forms/Select'
import NumberField from 'components/forms/NumberField'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import RpqsAction from 'rpqs/actions/RpqsAction'
import Input from 'components/forms/Input'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import ToastrAction from 'toastr/actions/ToastrAction'

const DialogCreateRPQS = ({
    open = false,
    onClose = () => {},
}) => {
    const {
        collectivities,
    } = useSelector(store => ({
        collectivities: store.RpqsReducer.collectivities,
    }), shallowEqual)

    const dispatch = useDispatch()

    const [name, setName] = useState('')
    const [year, setYear] = useState('')
    const [collectivityId, setCollectivityId] = useState()
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    const onValidate = () => {
        if (!name || !year || !collectivityId) {
            dispatch(ToastrAction.error(i18n.allFieldsAreRequired))
            return
        }

        dispatch(RpqsAction.createRpqs({
            name,
            year,
            collectivityId,
            startDate,
            endDate,
        }))
        onClose()
    }

    return (
        <Dialog open={open} maxWidth='lg'>
            <DefaultDialogTitle title={i18n.createNewRPQS} onClose={onClose} />
            <DialogContent>
                <Grid container columnSpacing={1}>
                    <Grid size={12}>
                        <Input
                            title={i18n.name}
                            value={name}
                            onChange={setName}
                            obligatory
                        />
                    </Grid>
                    <Grid size={6}>
                        <NumberField
                            title={i18n.year}
                            value={year}
                            onChange={setYear}
                            maxLength={4}
                            obligatory
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            label={i18n.collectivity}
                            options={collectivities.map(c => ({ value: c.id, label: c.name }))}
                            value={collectivityId}
                            onChange={setCollectivityId}
                            obligatory
                        />
                    </Grid>
                    <Grid size={6}>
                        <SimpleDatePicker
                            label={i18n.startDate}
                            value={startDate}
                            onChange={setStartDate}
                        />
                    </Grid>
                    <Grid size={6}>
                        <SimpleDatePicker
                            label={i18n.endDate}
                            value={endDate}
                            onChange={setEndDate}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {i18n.close}
                </Button>
                <Button onClick={onValidate} variant='contained' color='primary'>
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogCreateRPQS.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
}

export default DialogCreateRPQS